/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_LeagueInputs */



/**
* | output |
* | --- |
* | "League" |
*
* @param {Tfield_LeagueInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_league = /** @type {((inputs?: Tfield_LeagueInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_LeagueInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ligue")
	if (locale === "es") return /** @type {LocalizedString} */ ("Liga")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Liga")
	if (locale === "it") return /** @type {LocalizedString} */ ("Campionato")
	return /** @type {LocalizedString} */ ("League")
});